import { Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { registrationFormService } from "../../shared/api/registrationForms";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { StaticStepForm } from "./StaticStepForm";

export const RegistrationNominateReplacementPage = () => {
	const {
		registrationForm: { id },
		nominateReplacement,
	} = useRegistrationForm();
	const { data, isLoading } = useQuery({
		queryKey: registrationFormService.keys.showConfirmReplacement(id),
		queryFn: () => registrationFormService.showConfirmReplacement(id).then((x) => x.data.data),
	});

	if (isLoading) {
		return <Loading />;
	}

	if (!data || !data.step) {
		return null;
	}

	return <StaticStepForm step={data.step} handleSubmit={nominateReplacement} />;
};
